import React from 'react';
import type { SiteRagReport } from '../../../types/siteRag';
import {
  buildGridLedStandbyPlanningReportContent,
  readGridLedStandbyPlanningReportProjection,
} from '../../../lib/generationImpact/gridLedStandbyPlanningReportContent';
import { SectionShell } from './SectionShell';
import { CitedReportProse } from '../report/CitedReportProse';

/** Shared private/public/native-PDF body over the saved public allowlist only. */
export const GridLedStandbyPlanningSection: React.FC<{ report: SiteRagReport; label: string }> = ({ report, label }) => {
  const projection = readGridLedStandbyPlanningReportProjection(report);
  if (!projection) return null;
  const content = buildGridLedStandbyPlanningReportContent(projection);
  return (
    <SectionShell label={label} hasData>
      <div className="space-y-4" data-grid-led-standby-planning="frozen">
        <p className="font-semibold">{content.headline}</p>
        <p>{content.authority}</p>
        {content.sections.map(section => (
          <div key={section.heading}>
            <h3 className="mb-2 font-semibold">{section.heading}</h3>
            <table className="w-full text-sm" data-export-capture="table">
              <thead>
                <tr><th className="text-left">Planning quantity</th><th className="text-left">Frozen value</th></tr>
              </thead>
              <tbody>
                {section.rows.map(([name, value]) => (
                  <tr key={name}>
                    <th scope="row" className="border-b py-1 pr-4 text-left font-normal">{name}</th>
                    <td className="border-b py-1 break-words">{value}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ))}
        {content.citations.length > 0 && <CitedReportProse text={`Declared planning basis: ${content.citations.join(' ')}`} references={report.references} />}
        <div>
          <h3 className="mb-2 font-semibold">Qualification limits</h3>
          <ul className="list-disc space-y-1 pl-5">
            {content.limitations.map(limitation => <li key={limitation}>{limitation}</li>)}
          </ul>
        </div>
      </div>
    </SectionShell>
  );
};
